import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ccard__block" }
const _hoisted_2 = { class: "ccard__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "ccard__header-title" }, "Персональные сборки", -1)
const _hoisted_4 = { class: "ccard__chips" }
const _hoisted_5 = { class: "ccard__build-cards" }
const _hoisted_6 = {
  key: 0,
  class: "ccard__tutorial"
}
const _hoisted_7 = {
  key: 1,
  class: "ccard__load-more"
}
const _hoisted_8 = { class: "ccard__load-more-desc" }
const _hoisted_9 = { class: "ccard__load-more-number" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-m btn-secondary" }, "Показать еще", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonalBuildCard = _resolveComponent("PersonalBuildCard")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["chip ccard__chip", { active: _ctx.chosenFilter === 'all' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setFilter('all')))
        }, [
          _createTextVNode(" Все ")
        ], 2)), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["chip ccard__chip", { active: _ctx.chosenFilter === 'my' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFilter('my')))
        }, [
          _createTextVNode(" Мои "),
          (_ctx.myBuildsAmount > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" (" + _toDisplayString(_ctx.myBuildsAmount) + ") ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ], 2)), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["chip ccard__chip", { active: _ctx.chosenFilter === 'liked' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFilter('liked')))
        }, [
          _createTextVNode(" Избранные "),
          (_ctx.likedBuildsAmount > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" (" + _toDisplayString(_ctx.likedBuildsAmount) + ") ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ], 2)), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredData, (item) => {
        return (_openBlock(), _createBlock(_component_PersonalBuildCard, {
          key: item.dbId,
          item: item,
          loadedUserData: _ctx.loadedUserData[item.data.author] || _ctx.defaultUserData,
          isPinned: _ctx.pinnedSet.has(item.dbId),
          onTogglePin: _ctx.onTogglePin
        }, null, 8, ["item", "loadedUserData", "isPinned", "onTogglePin"]))
      }), 128))
    ]),
    (
				(!_ctx.hasLikedAndOwnedBuilds || _ctx.likedBuildsAmount === 0) &&
				_ctx.$store.state.settings.showTutorial
			)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          (_ctx.myBuildsAmount === 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" ♡ Создайте свою, или лайкните сборки других и они появятся здесь! ")
              ], 64))
            : (_ctx.likedBuildsAmount === 0 && _ctx.chosenFilter !== 'my')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" ♡ Лайкните сборки других и они появятся здесь! ")
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.buildsLeftUnloaded > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createTextVNode(" Есть еще "),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.buildsLeftUnloaded) + " " + _toDisplayString(_ctx.getDeclension(_ctx.buildsLeftUnloaded, ['сборка', 'сборки', 'сборок'])), 1)
          ]),
          _hoisted_10
        ]))
      : _createCommentVNode("", true)
  ]))
}